module.exports = __webpack_public_path__ + "static/img/frame-measurement.b232e7e.png";


//////////////////
// WEBPACK FOOTER
// ./static/assets/img/FamilyImages/frame-measurement.png
// module id = 358
// module chunks = 4